import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { QData } from "../../../types/basic-type-list";
import { ICountry, IState, ICity, LocationFormValues } from "../../../types/api/location";
import { TResponseWithQData } from "../../../types/common";

// --- COUNTRY ---
export async function countryList(
  qData: QData & { search?: string; status?: string }
): Promise<AxiosResponse<TResponseWithQData<ICountry[]>>> {
  return axios.get(API_ENDPOINTS.LOCATION_COUNTRY_LIST, { params: qData });
}

export async function countryDetail(
  id: string
): Promise<AxiosResponse<ICountry>> {
  return axios.get(`${API_ENDPOINTS.LOCATION_COUNTRY_DETAIL}/${id}`);
}

export async function createCountry(
  payload: LocationFormValues
): Promise<AxiosResponse<ICountry>> {
  return axios.post(API_ENDPOINTS.LOCATION_COUNTRY_SAVE, payload);
}

export async function updateCountry({
  id,
  payload,
}: {
  id: string;
  payload: Partial<LocationFormValues>;
}): Promise<AxiosResponse<ICountry>> {
  return axios.put(`${API_ENDPOINTS.LOCATION_COUNTRY_SAVE}/${id}`, payload);
}

export async function deleteCountry(id: string): Promise<AxiosResponse<null>> {
  return axios.delete(`${API_ENDPOINTS.LOCATION_COUNTRY_DELETE}/${id}`);
}

// --- STATE ---
export async function stateList(
  qData: QData & { search?: string; status?: string; countryId?: string }
): Promise<AxiosResponse<TResponseWithQData<IState[]>>> {
  return axios.get(API_ENDPOINTS.LOCATION_STATE_LIST, { params: qData });
}

export async function stateDetail(id: string): Promise<AxiosResponse<IState>> {
  return axios.get(`${API_ENDPOINTS.LOCATION_STATE_DETAIL}/${id}`);
}

export async function createState(
  payload: LocationFormValues
): Promise<AxiosResponse<IState>> {
  return axios.post(API_ENDPOINTS.LOCATION_STATE_SAVE, payload);
}

export async function updateState({
  id,
  payload,
}: {
  id: string;
  payload: Partial<LocationFormValues>;
}): Promise<AxiosResponse<IState>> {
  return axios.put(`${API_ENDPOINTS.LOCATION_STATE_SAVE}/${id}`, payload);
}

export async function deleteState(id: string): Promise<AxiosResponse<null>> {
  return axios.delete(`${API_ENDPOINTS.LOCATION_STATE_DELETE}/${id}`);
}

// --- CITY ---
export async function cityList(
  qData: QData & { search?: string; status?: string; countryId?: string; stateId?: string }
): Promise<AxiosResponse<TResponseWithQData<ICity[]>>> {
  return axios.get(API_ENDPOINTS.LOCATION_CITY_LIST, { params: qData });
}

export async function cityDetail(id: string): Promise<AxiosResponse<ICity>> {
  return axios.get(`${API_ENDPOINTS.LOCATION_CITY_DETAIL}/${id}`);
}

export async function createCity(
  payload: LocationFormValues
): Promise<AxiosResponse<ICity>> {
  return axios.post(API_ENDPOINTS.LOCATION_CITY_SAVE, payload);
}

export async function updateCity({
  id,
  payload,
}: {
  id: string;
  payload: Partial<LocationFormValues>;
}): Promise<AxiosResponse<ICity>> {
  return axios.put(`${API_ENDPOINTS.LOCATION_CITY_SAVE}/${id}`, payload);
}

export async function deleteCity(id: string): Promise<AxiosResponse<null>> {
  return axios.delete(`${API_ENDPOINTS.LOCATION_CITY_DELETE}/${id}`);
}
